angular.module('app.filters')
.filter('filterLawyers', [
  "$log", "$filter", function($log, $filter) {
    return function(filterStatus, filterPQE, filterPractice, lawyersList) {
      var filteredLawyers;
      filteredLawyers = angular.copy(lawyersList);
      if (filterStatus !== "" && filterStatus !== "All") {
        filteredLawyers = $filter('filter')(filteredLawyers, {
          'lawyer_Status': filterStatus
        });
      }
      if (filterPQE !== "" && filterPQE !== "All") {
        if (filterPQE !== "< 0" && filterPQE !== "> 10") {
          filteredLawyers = $filter('filter')(filteredLawyers, {
            'PQE': parseInt(filterPQE)
          }, true);
        } else if (filterPQE === "< 0") {
          filteredLawyers = $filter('lessThanFilter')(filteredLawyers, "PQE", 0);
        } else if (filterPQE === "> 10") {
          filteredLawyers = $filter('greaterThanFilter')(filteredLawyers, "PQE", 10);
        }
      }
      if (!_.isEmpty(filterPractice) && filterPractice.practice_ID !== 0) {
        filteredLawyers = $filter('selectedTagsLawyers')(filteredLawyers, filterPractice.practice_ID);
      }
      return filteredLawyers;
    };
  }
])


// WEBPACK FOOTER //
// ./scripts/shared/filters/lawyers.js